export { SingleCulturalObjectPage } from "./single-cultural-object-page";
